import { SearchResultCategory } from '@/types/graphql';

export const SEARCH_SUGGESTIONS = [
  'How much does an AE make at Salesforce?',
  'How much can I make with Bravado Flex?',
  'What is it like working at Gong?',
  'Salesloft vs Outreach',
  'Should I send a thank you note after an interview?',
];

export const SEARCH_CATEGORY_SLUGS_MAP = new Map<SearchResultCategory, string>([
  [SearchResultCategory.AcademyArticles, 'articles'],
  [SearchResultCategory.Companies, 'companies'],
  [SearchResultCategory.CompanyPagesCatalogs, 'pages'],
  [SearchResultCategory.UserPortfolios, 'people'],
  [SearchResultCategory.WrComments, 'comments'],
  [SearchResultCategory.WrPosts, 'posts'],
  [SearchResultCategory.WrUsers, 'users'],
  [SearchResultCategory.Content, 'content'],
]);

export const CONTENT_CATEGORY_SLUGS: SearchResultCategory[] = [
  SearchResultCategory.AcademyArticles,
  SearchResultCategory.WrPosts,
  SearchResultCategory.CompanyPagesCatalogs,
];
